import React from 'react';
import { Button } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

export default function MobileNavigationMenu({ navigate }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{float:"right", display:"inline block"}}>
            <Button
                aria-controls="nationalDataNavigation"
                aria-haspopup="true"
                onClick={handleClick}
                variant="contained"
                className="navigationButtonNationalData"
                color="secondary"
                style={{ borderRadius: "0px" }}
                disableElevation>
                National Data
            </Button>
            <Menu
                elevation={0}
                id="nationalDataNavigation"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                getContentAnchorEl={null}
                style={{ border: "1px solid #686868 !important" }}>
                    <MenuItem onClick={() => navigate("2022Data")}>2022 National Summary Data</MenuItem><hr />
                    <MenuItem style={{ textDecoration: "none", textTransform: "none" }} onClick={() => navigate("2023Data")}>2023 Preliminary National Data</MenuItem>
            </Menu>
        </div>
    );
}